/**
 * Must load before variant-selector.js (via defer + document order).
 * Patches the class prototype before customElements.define upgrades instances,
 * so constructor-time total() / sibling iteration does not throw, and option()
 * ignores unknown names (e.g. SmartSizing _n.trigger("change") with mismatched keys).
 */
(function () {
  if (!window.customElements || typeof customElements.define !== "function") return;
  if (customElements.__variantSelectorDefineWrapped) return;
  customElements.__variantSelectorDefineWrapped = true;

  var originalDefine = customElements.define.bind(customElements);

  customElements.define = function (name, Constructor, options) {
    if (name === "variant-selector" && Constructor && Constructor.prototype) {
      var proto = Constructor.prototype;

      if (!proto.__neptunePrePatch) {
        proto.__neptunePrePatch = true;

        var origOption = proto.option;
        if (typeof origOption === "function") {
          proto.option = function (optionName, value) {
            var self = this;
            if (!self.data || !Array.isArray(self.data.options)) return;
            var resolvedName = optionName;
            var found = self.data.options.find(function (o) {
              var nm = typeof o === "string" ? o : o && o.name;
              return nm === resolvedName;
            });

            if (!found) {
              var m = /^option(\\d+)___/.exec(optionName || "");
              if (m) {
                var idx = parseInt(m[1], 10) - 1;
                if (idx >= 0 && idx < self.data.options.length) {
                  var opt = self.data.options[idx];
                  resolvedName = typeof opt === "string" ? opt : opt && opt.name;
                  found = !!resolvedName;
                }
              }
            }

            if (!found) return;
            return origOption.call(this, resolvedName, value);
          };
        }

        var origTotal = proto.total;
        if (typeof origTotal === "function") {
          proto.total = function () {
            try {
              return origTotal.call(this);
            } catch (e) {
              /* sibling variant-selector not upgraded yet, or missing .data */
            }
          };
        }

        var origValidate = proto.validate;
        if (typeof origValidate === "function") {
          proto.validate = function () {
            try {
              return origValidate.call(this);
            } catch (e) {}
          };
        }

        var origVariant = proto.variant;
        if (typeof origVariant === "function") {
          proto.variant = function () {
            var self = this;
            if (!self.data || !Array.isArray(self.data.variants) || !Array.isArray(self.data.options)) {
              return origVariant.call(this);
            }

            // Force all variants available — no inventory tracking on this store.
            self.data.variants.forEach(function (v) { if (v) v.available = true; });

            var matches = self.data.variants.slice();
            self.data.options
              .filter(function (o) {
                return !!o && !!o.selected;
              })
              .forEach(function (o) {
                matches = matches.filter(function (v) {
                  return v && Array.isArray(v.options) && v.options[o.index] == o.selected.value;
                });
              });

            self.data.variant =
              self.data.preselect || (matches.length === 1 && self.data.options.some(function (o) { return !!o.selected; }))
                ? matches[0] || null
                : null;
          };
        }

        // Patch availability() so it never marks options as sold out.
        var origAvailability = proto.availability;
        if (typeof origAvailability === "function") {
          proto.availability = function () {
            var self = this;
            if (self.data && Array.isArray(self.data.variants)) {
              self.data.variants.forEach(function (v) { if (v) v.available = true; });
            }
            return origAvailability.call(this);
          };
        }
      }
    }

    return originalDefine(name, Constructor, options);
  };
})();

